/**
 * Replaces the primary scan and the supplementary scans (with their per-scan transforms) for a
 * model version, via PUT api/v1/modelversions/{assetId}/{id}/scans. Only the model version is
 * modified — the underlying scan records are never touched.
 */
export default class UpdateModelVersionScansModel {
    id = null;
    assetId = null;
    associatedScanId = null;
    supplementaryScans = [];
    primaryScanTrimRadius = 0;
    primaryScanDecimationValue = 0;
    primaryScanScale = 1;

    /**
     * @param {string} id - the model version id.
     * @param {string} assetId
     * @param {string} associatedScanId - the primary (base) scan for this version.
     * @param {ScanAssociation[]} supplementaryScans - extra scans layered onto the primary, each with its transform, trim radius and decimation.
     * @param {number} [primaryScanTrimRadius=0] - camera-helper trim radius for the primary scan (0 = no trim).
     * @param {number} [primaryScanDecimationValue=0] - decimation (% of points to remove) for the primary scan (0 = none).
     * @param {number} [primaryScanScale=1] - uniform scale for the primary (base) scan (render-only; 1 = no scaling).
     */
    constructor(id, assetId, associatedScanId, supplementaryScans, primaryScanTrimRadius = 0, primaryScanDecimationValue = 0, primaryScanScale = 1){
        this.id = id;
        this.assetId = assetId;
        this.associatedScanId = associatedScanId;
        this.supplementaryScans = supplementaryScans ?? [];
        this.primaryScanTrimRadius = primaryScanTrimRadius;
        this.primaryScanDecimationValue = primaryScanDecimationValue;
        this.primaryScanScale = primaryScanScale;
    }
}
